export const REQUEST_CONFIRM_CODE = 'REQUEST_CONFIRM_CODE';
export const SEND_CONFIRM_CODE = 'SEND_CONFIRM_CODE';
export const SET_CONFIRM_SMS_CODE_FETCH = 'SET_CONFIRM_SMS_CODE_FETCH';
export const SET_INPUT_WARNING = 'SET_INPUT_WARNING';
export const SET_TIMER_START = '/confirmSMS/set-time-start';
export const SET_OTP_ID = '/confirmSMS/set-otp-id';
